import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-pie',
    templateUrl: './pie.component.html',
    styleUrls: ['./pie.component.scss'],
})
export class PieComponent implements OnInit {
    @Input() count = 3;
    @Input() activeCount = 3;
    @Input() pendingCount = 0;
    @Input() isAlwaysGreen = false;
    @Input() isAlwaysChunked = false;

    pieStyle: string;
    completed = false;

    constructor() {
    }

    ngOnInit() {
        this.getPieStyle();
    }

    getPieStyle() {
        let result = '';
        const gapLength = 2;
        const gapColor = '#ffffff';
        const iColor = '#ececec';
        const aColor = this.count === this.activeCount ? '#0ba700' : ( this.isAlwaysGreen ? '#0ba700' : '#373737');
        this.completed = !this.isAlwaysChunked && this.count > 0 && this.count === this.activeCount;

        let step = 0;

        if (this.count > 0) {
            const arcLength = (100 - (gapLength * this.count)) / this.count;

            for (let i = 1; i <= this.count; i++) {
                result += (this.getColorForArc(i)) + ' ' + step + '% ' + (step + arcLength) + '%,';
                step += arcLength;
                result += gapColor + ' ' + step + '% ' + (step + gapLength) + '%,';
                step += gapLength;
            }
            result = result.substring(0, result.length - 1);
        } else {
            result = iColor + ' 0% 100%';
        }
        this.pieStyle = `radial-gradient(white 56%, transparent 56%), conic-gradient(${result})`;
    }

    getColorForArc(i) {
      const aColor = this.count === this.activeCount ? '#0ba700' : ( this.isAlwaysGreen ? '#0ba700' : '#373737');
      const pColor = '#ff8c00';
      const iColor = '#ececec';

      if (i <= this.activeCount) {
        return aColor;
      } else if (i <= this.activeCount + this.pendingCount) {
        return pColor;
      } else {
        return iColor;
      }
    }

}
